import React from "react";

const ScheduelIconWithNumber = (props: any) => {
  return (
    <svg
      width="36"
      height="28"
      viewBox="0 0 36 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.79535 11.1891H5.74348V13H3.93855V11.1891H0.20918V9.90414L4.04016 4.26227H5.74348V9.75473H6.79535V11.1891ZM3.93855 9.75473V8.27254C3.93855 8.13309 3.94055 7.96773 3.94453 7.77648C3.9525 7.58523 3.96047 7.39398 3.96844 7.20273C3.97641 7.01148 3.98437 6.84215 3.99234 6.69473C4.0043 6.54332 4.01227 6.43773 4.01625 6.37797H3.96844C3.89273 6.54133 3.81305 6.7007 3.72937 6.85609C3.6457 7.0075 3.54809 7.16688 3.43652 7.33422L1.8348 9.75473H3.93855Z"
        fill="currentColor"
      />
      <path
        d="M22.853 5.36719H29.7464C30.9504 5.36719 31.9163 6.34628 31.9163 7.53707V21.3635C31.9163 22.5675 30.9372 23.5333 29.7464 23.5333H23.6337"
        stroke="currentColor"
        stroke-width="1.13719"
        stroke-miterlimit="10"
      />
      <path
        d="M12.4404 21.3635V7.53707C12.4404 6.33305 13.4195 5.36719 14.6103 5.36719H17.6667"
        stroke="currentColor"
        stroke-width="1.13719"
        stroke-miterlimit="10"
      />
      <path
        d="M12.4404 10.6055H31.9165"
        stroke="currentColor"
        stroke-width="1.13719"
        stroke-miterlimit="10"
      />
      <path
        d="M16.3169 3.69922V7.25836"
        stroke="currentColor"
        stroke-width="1.13719"
        stroke-miterlimit="10"
      />
      <path
        d="M27.9077 3.69922V7.25836"
        stroke="currentColor"
        stroke-width="1.13719"
        stroke-miterlimit="10"
      />
      <path
        d="M14.3193 14.4297H17.3889"
        stroke="currentColor"
        stroke-width="1.13719"
        stroke-miterlimit="10"
      />
      <path
        d="M20.6436 14.4297H23.7131"
        stroke="currentColor"
        stroke-width="1.13719"
        stroke-miterlimit="10"
      />
      <path
        d="M26.9683 14.4297H30.0379"
        stroke="currentColor"
        stroke-width="1.13719"
        stroke-miterlimit="10"
      />
      <path
        d="M14.3193 18.2656H17.3889"
        stroke="currentColor"
        stroke-width="1.13719"
        stroke-miterlimit="10"
      />
      <path
        d="M20.6436 18.2656H23.7131"
        stroke="currentColor"
        stroke-width="1.13719"
        stroke-miterlimit="10"
      />
      <path
        d="M26.9683 18.2656H30.0379"
        stroke="currentColor"
        stroke-width="1.13719"
        stroke-miterlimit="10"
      />
    </svg>
  );
};

export default ScheduelIconWithNumber;
